(function($) {

	$.fn.programSwitcher = function() {

		return this.each(function() {
			var $this = $(this);

            var source = {
                datatype: "json",
                datafields: [
                    { name: 'programName' },
                    { name: 'programCode' },
                    { name: 'idProgram' },
                    { name: 'programClass' },
                    { name: 'programDefault' },
                    { name: 'programActive' },
                    { name: 'programPublished' },
                    { name: 'programImage' },
                    { name: 'selectedProgramImage' }
                ],
                url: $this.data('url'),
                cache: true,
                async: true
            };
            var dataAdapter = new $.jqx.dataAdapter(source);

            // Create a jqxDropDownList
            $this.jqxDropDownList({
                source: dataAdapter,
                theme: 'trackit',
                displayMember: 'programName',
                valueMember: 'idProgram',
                width: 400,
                placeHolder: ''});

            var $hidden = $this.find('input:hidden');
            $hidden.attr('name', 'idCurrentProgram');

            // Render programs
            $this.jqxDropDownList('renderer', function (index, label, value) {
                var item = $this.jqxDropDownList('getItem', index).originalItem;
                var items = $this.jqxDropDownList('getItems');

                var $item = $('<div />').addClass('program-switcher-program').addClass(item.programClass);
                if (item.programImage) {
                    var $image = $('<img />').attr('src', url(item.programImage));
                    var $imageContainer = $('<span/>').addClass('logo').append($image);
                    $item.append($imageContainer);
                }
                var $name = $('<span />').addClass('name').text(item.programName + item.programDefault + item.programActive + item.programPublished);
                $item.append($name);
                return $item.wrapAll('<div />').parent().html();
            });

            $this.jqxDropDownList('selectionRenderer', function (htmlString)
            {
                if (htmlString) {
                    var selectedItem = $this.jqxDropDownList('getSelectedItem');
                    if (selectedItem) {
                        var item = selectedItem.originalItem;
                        var $item = $('<div />').addClass('program-switcher-program-selected');
                        if (item.selectedProgramImage) {
                            var $image = $('<img />').attr('src', url(item.selectedProgramImage));
                            var $imageContainer = $('<span/>').addClass('logo').append($image);
                            $item.append($imageContainer);
                            // Reduce the padding slightly to make it fit in the drop down
                            $image.imageLoader({spinner: {padding: 2}});
                        }
                        var $name = $('<span />').addClass('name').text(item.programName);
                        $item.append($name);
                        return $item;
                    } else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
            );

            $this.on('open', function (event) {
                var items = $this.jqxDropDownList('getItems');
                $.each(items, function( index, value ) {
                    var $image = $(value.element).find('img');
                    // Reset the src attr so that imageLoader is triggered
                    $image.attr('src', $image.attr('src')).imageLoader({spinner: { padding: 2 }});
                });
            });

            $this.on('bindingComplete', function (event) {
                // Set selected value
                $this.jqxDropDownList('val', $this.data('value'));

                // Set dimensions according to contents
                var items = $this.jqxDropDownList('getItems');
                var dropDownHeight = 0;
                $.each(items, function( index, value ) {
                    if (dropDownHeight < 400) {
                        dropDownHeight = Math.min(dropDownHeight + value.height, 400);
                    }
                    else
                    {
                        return false;
                    }
                });
                $this.jqxDropDownList('dropDownHeight', dropDownHeight+2);

                // Respond to selection
                $this.on('select', function (event) {
                    if ($hidden.val() != $this.data('value')) {
                        $this.closest('form').submit();
                    }
                });
            });

        });
	};

})(jQuery);